import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import classNames from 'classnames';
import {LibraryDialogController} from './LibraryDialog.controller';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {observer} from 'mobx-react';

interface LibraryDialogCarouselProps {
    ctrl: LibraryDialogController;
}

@observer
export class LibraryDialogCarousel extends React.Component<LibraryDialogCarouselProps> {
    renderArrowPrev = (clickHandler: () => void, hasPrev: boolean): JSX.Element => {
        const {ctrl} = this.props;
        return (
            <button
                type='button'
                onClick={clickHandler}
                className={classNames('carousel-arrow carousel-arrow-prev', {disabled: !hasPrev})}
                aria-label='Previous'>
                <img src={ctrl.requireImage('chevron-left-blue.png')} alt='Previous' />
            </button>
        );
    };

    renderArrowNext = (clickHandler: () => void, hasNext: boolean): JSX.Element => {
        const {ctrl} = this.props;
        return (
            <button
                type='button'
                onClick={clickHandler}
                className={classNames('carousel-arrow carousel-arrow-next', {disabled: !hasNext})}
                aria-label='Next'>
                <img src={ctrl.requireImage('chevron-right-blue.png')} alt='Next' />
            </button>
        );
    };

    render(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <Carousel
                selectedItem={ctrl.currentCarouselIndex}
                onChange={(index: number) => ctrl.setCarouselActive(index)}
                showStatus={false}
                showThumbs={false}
                infiniteLoop={true}
                renderArrowPrev={this.renderArrowPrev}
                renderArrowNext={this.renderArrowNext}>
                {ctrl.carouselItems.map((item, index) => (
                    <div key={index} className='carousel-slide'>
                        <img
                            src={item.data.data.type === 'img' ? item.data.data.url : ctrl.requireImage('file.png')}
                            alt={item.data.data.title}
                        />
                        <p className='legend'>{item.data.data.title}</p>
                    </div>
                ))}
            </Carousel>
        );
    }
}
